import { render } from "./WorkerProfile.vue?vue&type=template&id=c1f34c9a&scoped=true"
import script from "./WorkerProfile.vue?vue&type=script&lang=js"
export * from "./WorkerProfile.vue?vue&type=script&lang=js"

import "./WorkerProfile.vue?vue&type=style&index=0&id=c1f34c9a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1f34c9a"]])

export default __exports__